import React, { useState, useEffect } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    Snackbar,
    Alert,
    FormControlLabel,
    Switch,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { updateTimeslot, createTimeslot } from "../../Apis/TimeslotApi";

const CreateTimeslot = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const timeslotData = location.state?.timeslotData; // get timeslot via props
    const editMode = Boolean(timeslotData);

    const [time, setTime] = useState("");
    const [status, setStatus] = useState(true);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    useEffect(() => {
        if (editMode && timeslotData) {
            setTime(timeslotData.time || "");
            setStatus(timeslotData.status ?? true);
        }
    }, [editMode, timeslotData]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!time) {
            setErrorMsg("Please enter a time.");
            return;
        }

        const formData = { time, status };

        try {
            setLoading(true);
            if (editMode) {
                await updateTimeslot(timeslotData._id || timeslotData.id, formData);
            } else {
                await createTimeslot(formData);
            }
            setSuccess(true);
            setTimeout(() => navigate("/getadmintimeslot"), 1200);
        } catch (error) {
            setErrorMsg(editMode ? "Failed to update timeslot." : "Failed to create timeslot.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", px: 3, py: 4 }}>
            <Paper sx={{ width: "40%", p: 5, borderRadius: 3, boxShadow: 6 }}>
                <Typography variant="h5" gutterBottom>
                    {editMode ? "Update Timeslot" : "Create Timeslot"}
                </Typography>
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Time"
                        value={time}
                        onChange={(e) => setTime(e.target.value)}
                        fullWidth
                        margin="normal"
                        InputProps={{
                            sx: {
                                height: 40,
                                "& .MuiInputBase-input": {
                                    padding: "8px 14px",
                                }
                            }
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={status}
                                onChange={(e) => setStatus(e.target.checked)}
                            />
                        }
                        label="Active"
                    />
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        fullWidth
                        disabled={loading}
                        sx={{ mt: 2 }}
                    >
                        {loading ? (editMode ? "Updating..." : "Creating...") : (editMode ? "Update Timeslot" : "Create Timeslot")}
                    </Button>
                </form>
            </Paper>

            <Snackbar
                open={success}
                autoHideDuration={3000}
                onClose={() => setSuccess(false)}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert severity="success" variant="filled">
                    {editMode ? "Timeslot updated successfully!" : "Timeslot created successfully!"}
                </Alert>
            </Snackbar>

            <Snackbar
                open={!!errorMsg}
                autoHideDuration={4000}
                onClose={() => setErrorMsg("")}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert severity="error" variant="filled">
                    {errorMsg}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default CreateTimeslot;
